module.exports = __webpack_public_path__ + "intro.96f62c7e.svg";